import React from 'react';

const AllOrEmptyLocations = () => (
  <div className="u-mv" data-automation-id="schedule-tab">
    <div className="layout">
      <div className="layout__item">
        <span className="c-heading c-heading--lightgrey c-wrapper u-pv0">Please select location</span>
      </div>
    </div>
  </div>
);

export default AllOrEmptyLocations;
